import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "water-detail-top-wrapper" }
const _hoisted_2 = { class: "station-selector-wrapper" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "water-detail-top" }

import { computed, onMounted, onUnmounted, watch, ref } from 'vue'
import { useRoute } from 'vue-router'
import moment from 'moment'
import CurrentDataPanel from '@/components/water_detail/CurrentDataPanel.vue'
import DiagramPanel from '@/components/water_detail/DiagramPanel.vue'
import GraphPanel from '@/components/water_detail/GraphPanel.vue'
import StationSelector from '@/components/common/StationSelector.vue'
import ControllPanel from '@/components/common/ControllPanel.vue'
import { useWaterDetailStore } from '@/stores/waterDetailStore'
import { useGlobalStore } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const FETCH_INTERVAL = 60 * 1000 // 1分
const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const route = useRoute()
const waterDetailStore = useWaterDetailStore()
const stationId = computed(() => {
  return globalStore.currentStation?.stationId
})

const resolution = ref<string>('ten_min')
const timer = ref<number>(0)

const fetch = (d: Date = new Date()) => {
  waterDetailStore.fetch(stationId.value as string, resolution.value, d)
}

const attachCurrentStation = () => {
  const station = initDataStore.initData.stationList.find(station => station.stationId === route.params.stationId)
  const areaCode = station?.areaCode[0]

  if (!areaCode) {
    return
  }

  const area = initDataStore.areaList.find(area => area.id === areaCode)

  globalStore.currentArea = area
  globalStore.currentStation = station
}

const resolutions = [
  { label: '10分', value: 'ten_min' },
  { label: '1時間', value: 'half_day' },
]

const handleChangeDate = (date: Date) => {
  const format = 'YYYYMMDDHH'

  if (moment(date).format(format) === moment().format(format)) {
    globalStore.startAutoUpdate()
  } else {
    globalStore.stopAutoUpdate()
  }

  fetch(date)
}

onMounted(() => {
  globalStore.startAutoUpdate()

  if (initDataStore.initData) {
    attachCurrentStation()
  }
  fetch()

  timer.value = setInterval(fetch, FETCH_INTERVAL)
})

onUnmounted(() => {
  clearInterval(timer.value)
})

watch(() => initDataStore.initData, attachCurrentStation)

watch(
  () => globalStore.currentStation,
  () => fetch()
)
watch(
  () => resolution.value,
  () => fetch()
)

return (_ctx: any,_cache: any) => {
  const _component_UdcSelect = _resolveComponent("UdcSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StationSelector, { "station-type": "water" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ControllPanel, {
          onChangeDate: handleChangeDate,
          "default-resolution": resolution.value,
          "default-date": new Date(),
          "show-resolution": false,
          "hide-minute-selector": true,
          class: "flex-center hide-sp"
        }, null, 8, ["default-resolution", "default-date"]),
        _createVNode(_component_UdcSelect, {
          modelValue: resolution.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resolution).value = $event)),
          options: resolutions,
          class: "hide-sp"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CurrentDataPanel, { resolution: resolution.value }, null, 8, ["resolution"]),
      _createVNode(DiagramPanel),
      _createVNode(GraphPanel, { class: "hide-sp" })
    ])
  ]))
}
}

})